window.getGeolocation = function getGeolocation(firstTime = false) {
    if (firstTime) {
        setDefaultGeolocation(firstTime);
    }

    window.geolocationPermission = false;

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                if (position.coords.latitude !== 'undefined') {
                    window.geolocationPermission = true;
                    
                    window.geolocation = {
                        'longitude': position.coords.longitude,
                        'latitude': position.coords.latitude
                    }
                    $('#search_longitude').val(position.coords.longitude);
                    $('#search_latitude').val(position.coords.latitude);
                } else {
                    setDefaultGeolocation(firstTime);
                }
            },
            function (error) {
                if (error.code === error.PERMISSION_DENIED) {
                    // Handle permission denied case
                    console.log('User denied geolocation request');
                } else {
                    // Handle other error cases
                    console.log('Geolocation error: ' + error.message);
                }
                setDefaultGeolocation(firstTime);
            }
        );
    } else {
        console.log('Geolocation is not supported');
        setDefaultGeolocation(firstTime);
    }


    let cityEl = $('#currentCity');
    let longitudeEl = $('#search_longitude');
    let latitudeEl = $('#search_latitude');
    let filterEl = $('#search_city');
    $.ajax({
        url: cityEl.attr('data-url'),
        type: cityEl.attr('data-method'),
        dataType: 'json',
        data: window.geolocation,
        success: function (data) {
            if (data.status === true) {
                cityEl.val(data.results[0].cidade);
                longitudeEl.val(data.results[0].longitude);
                latitudeEl.val(data.results[0].latitude);
            }
        }
    });

    return window.geolocation;
}

window.setDefaultGeolocation = function setDefaultGeolocation(first_time = false) {
    let positionDefaultEl = $('#geolocation-default-data');
    window.geolocation = {
        'longitude': positionDefaultEl.attr('data-lon'),
        'latitude': positionDefaultEl.attr('data-lat')
    }
    $('#search_longitude').val(window.geolocation.longitude);
    $('#search_latitude').val(window.geolocation.latitude);
    if (first_time === false) {
        console.log('Geolocation not active - Grabbing default geolocation to Lisbon');
    }
}

getGeolocation(true);


$('body').on('click', '#geolocation-btn', function () {
    getGeolocation();
    let leafletIcon = $('.leaflet-control-locate-location-arrow');
    if (leafletIcon.length > 0) {
        leafletIcon.click();
        let leafletIconWrapper = $('.leaflet-control-locate');
        if (leafletIconWrapper.hasClass('following') === false) {
            leafletIcon.click();
        }
    }


    $.ajax({
        url: $(this).attr('data-action'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            latitude: window.geolocation.latitude,
            longitude: window.geolocation.longitude
        },
        dataType: 'JSON',
        success: function (data) {
            $('#search_city').val(data.city);
            $('#search-btn').click();
        }
    });
});
